module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0042.jpg?v=2af56a46";